import { render, staticRenderFns } from "./QuickInformationForm.vue?vue&type=template&id=78195224&"
import script from "./QuickInformationForm.vue?vue&type=script&lang=js&"
export * from "./QuickInformationForm.vue?vue&type=script&lang=js&"
import style0 from "./QuickInformationForm.vue?vue&type=style&index=0&scroped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports